import React, { useState } from 'react';
import { Button, Chip, DatePicker, Input, Radio, RadioGroup, Select } from '@trackman/web-shared-components';
import styled from 'styled-components';
import { filtersGrey } from 'styles/Colors';
import FilterType, { Filter } from './FilterType';
import { ReactComponent as FilterIcon } from '../../images/Tables/filter.svg';

const CurrentFilters = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 8px;
  .current-filter {
    display: flex;
    gap: 10px;
    .MuiChip-root {
      border-radius: 16px;
      padding: 16px 0;
    }
  }
`;

const PopupActivateButton = styled.div`
  z-index: 1;
  display: flex;
  height: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

const StyledButton = styled((props) => <Button {...props} />)`
  &.MuiButton-root {
    width: 100%;
  }
`;

const Content = styled.div`
  display: grid;
  gap: 20px;
  padding: 10px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);

  &::before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid #fff;
    position: absolute;
    top: -12px;
    left: calc(50% - 12px);
  }

  input {
    color: ${filtersGrey};
  }
  .MuiFormControl-root,
  .MuiFormControl-root .MuiSelect-root,
  .MuiFormControl-root .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl,
  .MuiFormControl-root .MuiFormHelperText-root.MuiFormHelperText-contained,
  .MuiFormControlLabel-root > span {
    color: ${filtersGrey};

    svg {
      fill: ${filtersGrey};
    }
  }
`;

const Backdrop = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
`;

const FilterButtonAndPopup = styled.div`
  margin-left: 5px;
  height: 100%;
  cursor: pointer;
  .popup {
    z-index: 2;
    cursor: default;
    position: absolute;
    margin-left: -140px;
    margin-top: 15px;
    width: 300px;
    height: auto;
  }
`;

const StyledChip = styled((props) => <Chip {...props} />)`
  .MuiChip-deleteIcon {
    height: unset;
  }
`;

export type FiltersData = { current: JSX.Element; contentIcons: JSX.Element[] };

export type FilterChip = {
  id: string;
  chipDescription: string;
  value: string;
  onRemove: (i: number) => void;
  type: string;
};

export const FilterChips = (filters: FilterChip[]) => {
  return (
    <CurrentFilters>{filters.length > 0 ? filters.map((f, index) => FChip(f, index)) : 'Added filters will appear here'}</CurrentFilters>
  );
};

const FChip = (f: FilterChip, index: number) => {
  return (
    <div key={index} className='current-filter'>
      <StyledChip size='small' key={index} label={f.chipDescription} color='#414141' onDelete={() => f.onRemove(index)} />
    </div>
  );
};

export const ColumnItems = (filters: FilterType[]) => {
  let lastColumn = filters[0].columnNumber;
  const columnFilters: JSX.Element[] = [];

  filters.forEach((f) => (lastColumn = Math.max(lastColumn, f.columnNumber)));
  for (let k = 0; k < lastColumn + 1; k++) {
    columnFilters.push(Column(filters.find((f) => f.columnNumber === k)));
  }
  return columnFilters;
};

const Column = (f: FilterType | undefined) => {
  const [menuOpen, setMenuOpen] = useState(false);

  if (!f) return <></>;

  const Popup = (f: FilterType) => {
    if (f.type === Filter.Textfields)
      return f.inputProps.map((ip, i) => {
        return <Input key={i} {...ip} />;
      });
    if (f.type === Filter.Select) return <Select {...f.selectProps} ref={undefined} />;
    if (f.type === Filter.Date) return <DatePicker {...f.datePickerProps} />;
    if (f.type === Filter.DateRange)
      return (
        <>
          <DatePicker {...f.startDateProps} />
          <DatePicker {...f.endDateProps} />
        </>
      );
    if (f.type === Filter.Radio)
      return (
        <RadioGroup>
          {f.radioProps.map((c, i) => (
            <Radio key={i} {...c} margin='3px' />
          ))}
        </RadioGroup>
      );
  };

  return (
    <FilterButtonAndPopup onClick={(e) => e.stopPropagation()}>
      <PopupActivateButton onClick={() => setMenuOpen(!menuOpen)}>
        <FilterIcon />
      </PopupActivateButton>
      <div className='popup'>
        {menuOpen && (
          <>
            <Backdrop onClick={() => setMenuOpen(false)} />
            <Content>
              {Popup(f)}
              <StyledButton
                label='Save filter'
                intent='primary'
                onClick={() => {
                  setMenuOpen(false);
                  f.onSave();
                }}
              />
            </Content>
          </>
        )}
      </div>
    </FilterButtonAndPopup>
  );
};
